// src/components/GallerySync.tsx
import * as React from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

const DEBUG_UI = (import.meta.env.VITE_DEBUG_UI || '').toString() === '1';

type Props = {
  label?: string;                 // customizable label
  onSync: () => Promise<void> | void;
  isLoading?: boolean;
  lastSyncTime?: string;
  className?: string;
};

export function GallerySync({
  label = "Gallery Sync",
  onSync,
  isLoading = false,
  lastSyncTime = "",
  className = "",
}: Props) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <Button
        variant="outline"
        size="sm"
        onClick={() => {
          if (DEBUG_UI) console.log(`[sync-btn] click -> ${label}`);
          return onSync();
        }}
        disabled={!!isLoading}
        className="h-auto px-2 py-1 text-xs rounded-full border-muted-foreground/30 data-[state=loading]:opacity-60"
        aria-busy={isLoading}
        aria-label={label}
      >
        <RefreshCw className={`h-3 w-3 mr-1 ${isLoading ? "animate-spin" : ""}`} />
        {isLoading ? "Syncing…" : label}
      </Button>

      <span className="text-muted-foreground text-xs">
        Last synced: {lastSyncTime || "Never"}
      </span>
    </div>
  );
}
